// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom/client';

import {ALLOWED_TIMEZONE} from 'graphql-client/__generated/GeneratedEnumMaps';
import {AllowedTimezone} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  institutionInfoLinksByUrl,
  LicensedInstitutionInfoLink,
} from 'help/institutions/InstitutionModalConstants';
import {Institution} from 'institutions/InstitutionConstants';
import InstitutionSelector from 'institutions/InstitutionSelector';
import NotificationPreferencesSection from 'notifications/preferences/NotificationPreferencesSection';
import ProfileAPISection from 'profile/ProfileAPISection';
import ProfileLocalePicker from 'profile/ProfileLocalePicker';
import ProfileMfaSection from 'profile/ProfileMfaSection';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import DataSharingConnectionInfo from 'warehouse/DataSharingConnectionInfo';
import WarehouseLogins from 'warehouse/WarehouseLogins';

class SelectedInstitution extends Backbone.Model {
  institution!: Institution | null;

  override initialize({institution}: {institution: Institution | null}): void {
    this.institution = institution;
  }
}

class ProfileSettingsView extends Backbone.View<Backbone.Model> {
  initialInstitution!: Institution | null;
  selectedInstitution!: SelectedInstitution;

  apiSectionReactRoot: ReactDOM.Root | null = null;
  dataSharingConnectionReactRoot: ReactDOM.Root | null = null;
  institutionInfoLinkReactRoot: ReactDOM.Root | null = null;
  institutionSelectorReactRoot: ReactDOM.Root | null = null;
  mfaSectionReactRoot: ReactDOM.Root | null = null;
  notificationPreferencesSectionReactRoot: ReactDOM.Root | null = null;
  profileLocalePickerReactRoot: ReactDOM.Root | null = null;
  warehouseLoginsReactRoot: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.el = '#settings';
    this.prototype.events = {
      // @ts-expect-error: This is a legit JQueryEventObject but it is not being recognized by TS
      'submit .add-member-form': 'handleAddMember',
    };
  }

  override initialize(): void {
    this.initialInstitution = window.bootstrap!.entity!.institution;
    this.selectedInstitution = new SelectedInstitution({institution: this.initialInstitution});
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.selectedInstitution, 'change', this.mountInstitutionInfoLink);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.selectedInstitution, 'change', this.mountInstitutionSelector);
  }

  mountInstitutionSelector(): void {
    const $mount = this.$('.js-institution.react-mount');

    if ($mount.length) {
      const model = this.selectedInstitution;
      this.institutionSelectorReactRoot = renderToDOM(
        <InstitutionSelector
          placeholder="No institution selected"
          allowLeaving={!this.initialInstitution?.licensed}
          value={model.get('institution')}
          onChange={(institution) => model.set({institution})}
          className="u-small-spacing-bottom"
          disabled={this.initialInstitution?.licensed}
        />,
        $mount[0],
        this.institutionSelectorReactRoot
      );
    }
  }

  mountLanguageTagPicker(): void {
    const $mount = this.$('.js-language-tag.react-mount');
    const name = 'language_tag';
    if ($mount.length) {
      this.profileLocalePickerReactRoot = renderToDOM(
        <ProfileLocalePicker
          name={name}
          // This input will exist at first, and then get clobbered by `ProfileLocalePicker`, which creates and
          // updates its own hidden input for the form
          initialValue={$mount.find(`input[name=${name}]`).val()}
        />,
        $mount[0],
        this.profileLocalePickerReactRoot
      );
    }
  }

  mountWarehouseLogins(): void {
    const $mount = this.$('.js-warehouse.react-mount');
    if (!$mount.length) {
      return;
    }
    this.warehouseLoginsReactRoot = renderToDOM(
      <WarehouseLogins />,
      $mount[0],
      this.warehouseLoginsReactRoot
    );
  }

  mountDataSharingConnectionInfo(): void {
    const $mount = this.$('.js-data-sharing-connection.react-mount');
    if (!$mount.length) {
      return;
    }
    this.dataSharingConnectionReactRoot = renderToDOM(
      <DataSharingConnectionInfo />,
      $mount[0],
      this.dataSharingConnectionReactRoot
    );
  }

  mountNotificationsOptOutSetting(): void {
    const $mount = this.$('.js-notifications-opt-out-setting.react-mount');
    if (!$mount.length) {
      return;
    }
    const deliveryTimezone = Object.keys(ALLOWED_TIMEZONE).find(
      (key: AllowedTimezone) => ALLOWED_TIMEZONE[key] === window.bootstrap!.notificationDeliveryTimezone
    ) as AllowedTimezone;
    this.notificationPreferencesSectionReactRoot = renderToDOM(
      <NotificationPreferencesSection
        notificationOptOutPreferences={window.bootstrap!.notificationOptOutPreferences}
        deliveryTimezonePreference={deliveryTimezone}
      />,
      $mount[0],
      this.notificationPreferencesSectionReactRoot
    );
  }

  mountAPISection(): void {
    const $mount = this.$('.js-api.react-mount');
    if (!$mount.length) {
      return;
    }
    this.apiSectionReactRoot = renderToDOM(<ProfileAPISection />, $mount[0], this.apiSectionReactRoot);
  }

  mountMfaSection(): void {
    const $mount = this.$('.js-mfa.react-mount');
    if (!$mount.length) {
      return;
    }
    this.mfaSectionReactRoot = renderToDOM(
      <ProfileMfaSection
        mfaEnabled={window.bootstrap?.mfa_enabled ?? false}
        canDisableMfa={window.bootstrap?.can_disable_mfa ?? false}
      />,
      $mount[0],
      this.mfaSectionReactRoot
    );
  }

  mountInstitutionInfoLink(): void {
    const $mount = this.$('.js-institution-info-link');
    if (!$mount.length) {
      return;
    }
    const institution: Institution | null = this.selectedInstitution.get('institution');
    const urlIdentifier = institution && institution.urlIdentifier;

    const urlInfoLink: (() => JSX.Element) | undefined =
      // @ts-expect-error urlIdentifier is probably not `broad`, the only key in `institutionInfoLinksByUrl`.
      // So we can expect to get back `undefined` here
      urlIdentifier && institutionInfoLinksByUrl[urlIdentifier];

    if (urlInfoLink) {
      this.institutionInfoLinkReactRoot = renderToDOM(
        React.createElement(urlInfoLink),
        $mount[0],
        this.institutionInfoLinkReactRoot
      );
    } else if (institution && institution.licensed) {
      this.institutionInfoLinkReactRoot = renderToDOM(
        <LicensedInstitutionInfoLink institution={institution} />,
        $mount[0],
        this.institutionInfoLinkReactRoot
      );
    } else {
      this.unmountInstitutionInfoLink($mount[0]);
    }
  }

  unmountInstitutionInfoLink($el: Element): void {
    this.institutionInfoLinkReactRoot = renderToDOM(<div />, $el, this.institutionInfoLinkReactRoot);
  }

  override render(): this {
    this.mountInstitutionSelector();
    this.mountInstitutionInfoLink();
    this.mountLanguageTagPicker();
    this.mountAPISection();
    this.mountMfaSection();

    this.mountWarehouseLogins();
    this.mountDataSharingConnectionInfo();
    this.mountNotificationsOptOutSetting();

    return this;
  }

  override remove(): Backbone.View<Backbone.Model> {
    unmountRootsAsync(
      [
        this.apiSectionReactRoot,
        this.dataSharingConnectionReactRoot,
        this.institutionInfoLinkReactRoot,
        this.institutionSelectorReactRoot,
        this.mfaSectionReactRoot,
        this.notificationPreferencesSectionReactRoot,
        this.profileLocalePickerReactRoot,
        this.warehouseLoginsReactRoot,
      ],
      () => {
        this.apiSectionReactRoot = null;
        this.dataSharingConnectionReactRoot = null;
        this.institutionInfoLinkReactRoot = null;
        this.institutionSelectorReactRoot = null;
        this.mfaSectionReactRoot = null;
        this.notificationPreferencesSectionReactRoot = null;
        this.profileLocalePickerReactRoot = null;
        this.warehouseLoginsReactRoot = null;
        super.remove();
      }
    );

    return this;
  }
}

ProfileSettingsView.initClass();

export default ProfileSettingsView;
